/* Libs */
import { tracking } from '@api/apis';
import { Logger } from '@utils/logger';
import { LEAD_GEN_SOURCE_TYPES } from './leadgen.constants';
import { replaceSpaces } from '@utils/formatting';
import segmentAnonymousId from '@utils/cookies/segmentAnonymousId';
import { setLeadGeneratedCookie } from '@utils/cookies/leadGeneration';

/* Types */
type SegmentTractionActionProps = {
  email: string;
  attributes?: Record<string, any>;
} & (
  | { sourceGroup?: { type: string; name: string }; name: string; type: string }
  | { sourceGroup: { type: string; name: string }; name?: string; type?: string }
);

/**
 * -------------------------------------------------------------------------------------
 * These are just "actions" that are consolidated in one place that
 * will return your properties structure. Just "method" out what you
 * need to handle.
 *
 *    * @param email
 *    * @param source
 *    * @param sourceNameOverride
 *    * @param name
 *    * @param type
 *    * @param page
 *    * @param attributes
 *    * @returns {Promise<void>}
 *
 */

export const LeadGeneratedTrackingEvent = ({ email, name, type, sourceGroup, attributes }: SegmentTractionActionProps) => {
  const updatedEmail = replaceSpaces(email);
  const attributeEmail = attributes?.email && replaceSpaces(attributes.email);

  const payload = {
    email: updatedEmail,
    source_name: name || sourceGroup?.name,
    source_type: type || sourceGroup?.type,
    anonymous_id: segmentAnonymousId(),
    ...(attributes && { ...attributes, ...(attributeEmail && { email: attributeEmail }) }),
  };

  const errMsg = `Error lead generation: ${window?.location?.pathname}`;
  try {
    tracking.leadGeneration(payload).then(resp => {
      if (resp && resp?.err) {
        Logger(errMsg)(resp.err);
      } else {
        setLeadGeneratedCookie({ email: updatedEmail });
      }
    });
  } catch (e) {
    Logger(errMsg)(e as Error);
  }
};

export { LEAD_GEN_SOURCE_TYPES };
